import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineTermsModal のスタイル
 */
export const hotlineTermsModalStyle = tv({
    slots: {
        base: [''],
        buttons: ['flex-col sm:flex-row-reverse'],
        contentWrap: [
            '!max-w-[min(800px,100%)]',
            'flex flex-col items-center',
            'lg:px-8',
        ],
        link: ['group', 'inline-flex items-center gap-4', 'mt-16'],
        linkText: [linkTextStyle({ isBold: true, isGroup: true, size: 'sm' })],
        termsContent: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex flex-col gap-y-16',
            'w-full h-[280px]',
            'border border-solid border-gray-300',
            'overflow-y-scroll',
        ],
    },
});
